import { type OnboardSurvey as MarketingData } from '@prerender/prerender-shared';

import { restApi } from '../../features/api/restApiSlice';

import type { Answers } from './questions';

const onboardingSurveyApiSlice = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getAnswers: builder.query<Answers, void>({
      query: () => '/v3/users/marketing',
      transformResponse: (response: MarketingData) => {
        const answers: Answers = {
          Department: response.department,
          Team_Role: response.team_role,
          Goal: response.goal,
          Team_Size_Survey: response.team_size_survey,
          Industry: response.industry,
          Source: response.source,
        };
        return answers;
      },
      providesTags: ['SurveyAnswers'],
    }),

    updateAnswers: builder.mutation<void, Answers>({
      query: (answers) => {
        // transform to lowecase keys
        const body = Object.fromEntries(Object.entries(answers).map(([key, value]) => [key.toLowerCase(), value]));
        return {
          url: '/v3/users/marketing',
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: ['SurveyAnswers'],
      // Each call sets one named field to one fixed value, so repeating it lands the
      // same record — safe to retry past a transient 5xx (PRE-3350).
      extraOptions: { retryOnServerError: true },
    }),
  }),
});

export const { useGetAnswersQuery, useLazyGetAnswersQuery, useUpdateAnswersMutation } = onboardingSurveyApiSlice;
